// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";
import CommonOutcomeInputForm from "./common-outcome-input-form";
import { Col, Row, View } from "@components";

type OwnProps = $Exact<{
  title: String,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export const CommonOutcomeInputView = (props: Props) => {
  return (
    <View>
      <h6>{props.title}</h6>
      <CommonOutcomeInputForm {...props} disabled={true} />
    </View>
  );
};

export default localize()(CommonOutcomeInputView);
